import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import { Grid } from "@mui/material";
import { studentRequests } from "api/studentApi";
import moment from "moment";
import React from "react";
import { Button, required, useNotify } from "react-admin";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import CustomTimeOnlyInput from "server/components/Fields/CustomTimeOnlyInput";
import RoomInput from "server/components/Fields/RoomInput";
import FormModal from "server/components/Modals/FormModal";
import { formatDateOnlyBg } from "server/formatting/formatDateBg";
import dataProvider from "server/dataProvider";

const validateStartTime = (value, allValues) => {
  if (!value && allValues.endTime) return "Въведете начален час";
  if (value && allValues.endTime && value >= allValues.endTime) return "Началният час трябва да е преди крайния";
  return undefined;
};

const validateEndTime = (value, allValues) => {
  if (allValues.startTime && !value) return "Въведете краен час";
  return undefined;
};

const RescheduleModal = ({ record, sessionDateRange, onSuccess }) => {
  const notify = useNotify();
  const hasReschedule = !!record.reschedule;

  const minDate = moment().add(1, "day").format("YYYY-MM-DD");
  const maxDate = sessionDateRange ? sessionDateRange.extendedEndsOn || sessionDateRange.endsOn : undefined;
  const isWeekendDate = date => [0, 6].includes(moment(date).day());

  // FormModal wraps onConfirm in its own try/catch (single toast, stays open) — no try/catch here
  const handleConfirm = async data => {
    await dataProvider.customRequest(
      studentRequests.updateWeeklyScheduleGroupReschedule(record.groupId),
      {
        originalDate: record.date,
        newDate: data.newDate,
        startTime: data.startTime || null,
        endTime: data.endTime || null,
        roomId: data.roomId || null,
      },
      "PUT",
    );

    notify("Занятието е пренасрочено успешно!", { type: "success" });

    if (onSuccess) {
      onSuccess();
    }
  };

  return (
    <FormModal
      titleContent={`Пренасрочване на занятие от ${formatDateOnlyBg(record.date)}`}
      dialogSize="md"
      onConfirm={handleConfirm}
      defaultValues={{
        newDate: record.reschedule?.newDate ?? null,
        startTime: record.reschedule?.startTime ?? record.startTime,
        endTime: record.reschedule?.endTime ?? record.endTime,
        roomId: record.reschedule?.roomId ?? record.roomId,
      }}
      triggerButton={
        <Button
          label={hasReschedule ? "Промени" : "Пренасрочи"}
          variant={hasReschedule ? "outlined" : "contained"}
          size="small"
          startIcon={<EditCalendarIcon />}
        />
      }
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <CustomDateInput
            source="newDate"
            label="Нова дата"
            noTime
            required
            validate={[required()]}
            minDate={minDate}
            maxDate={maxDate}
            shouldDisableDate={isWeekendDate}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
        >
          <CustomTimeOnlyInput
            source="startTime"
            label="Начален час"
            validate={[validateStartTime]}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
        >
          <CustomTimeOnlyInput
            source="endTime"
            label="Краен час"
            validate={[validateEndTime]}
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <RoomInput />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default RescheduleModal;
